// extracted by mini-css-extract-plugin
module.exports = {"cards":"LocationList_cards__1wSuH"};